import React from "react";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  FormControlLabel,
  MenuItem,
  Radio,
  Typography,
} from "@material-ui/core";
import { Field, Form, withFormik } from "formik";
import { RadioGroup, Switch, TextField } from "formik-material-ui";
import DocumentInput from "../Documents/DocumentInput";
import codes, { typesDocumentsCodes } from "../../common/codes";
import network from "../../../actions/external/network";
import {
  replaceEmptyStringByNull,
  replaceMomentObjectByString,
  replaceNullByEmptyString,
} from "../../../scripts/utils";
import DatePicker from "../../common/DatePicker";
import HVE1 from "./HVE1";
import HVE2 from "./HVE2";
import { Alert, AlertTitle } from "@material-ui/lab";
import { connect } from "react-redux";
import HVE4Static from "./HVE4/HVE4Static";

const mapStateToProps = (state) => ({
  auth: state.auth,
});

class DemarcheForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      organisme: null,
      mounted: false,
    };
  }

  componentDidMount() {
    this.setState({ mounted: true });
    this.loadOrganisme();
  }

  componentWillUnmount() {
    this.setState({ mounted: false });
  }

  componentDidUpdate(prevProps, prevState) {
    const { values, setFieldValue, structureCollective } = this.props;

    if (
      prevProps.values.exploitationDemarche.estCertificationEquivalente !==
      values.exploitationDemarche.estCertificationEquivalente
    ) {
      if (values.exploitationDemarche.estCertificationEquivalente) {
        setFieldValue("exploitationDemarche.certificationEquivalenteEstTotale", "true");
      } else {
        setFieldValue("exploitationDemarche.certificationEquivalenteEstTotale", null);
        setFieldValue("exploitationDemarche.certificationEquivalenteType", "");
        setFieldValue("exploitationDemarche.certificationEquivalenteDateCertification", null);
        setFieldValue("exploitationDemarche.certificationEquivalenteDateAudit", null);
        setFieldValue("exploitationDemarche.certificationEquivalenteDocument", null);
      }
    }
    if (
      prevProps.values.exploitationDemarche.estCollective !== values.exploitationDemarche.estCollective &&
      values.exploitationDemarche.estCollective === "false"
    ) {
      setFieldValue("exploitationDemarcheMillesime.nomStructureCollective", "");
    }
    if (
      prevProps.values.exploitationDemarcheMillesime.nomStructureCollective !==
      values.exploitationDemarcheMillesime.nomStructureCollective
    ) {
      const selectedStructureCollective = structureCollective.filter(
        (s) => s.idStructureCollective === values.exploitationDemarcheMillesime.nomStructureCollective
      )[0];
      if (selectedStructureCollective != null) {
        setFieldValue("exploitationDemarcheMillesime.siret", selectedStructureCollective.siret.replaceAll(" ", ""));
        setFieldValue("exploitationDemarcheMillesime.adresseAuditeurExterne", selectedStructureCollective.adresse);
        setFieldValue(
          "exploitationDemarcheMillesime.adresse2AuditeurExterne",
          selectedStructureCollective.complementAdresse
        );
        setFieldValue(
          "exploitationDemarcheMillesime.codePostalAuditeurExterne",
          selectedStructureCollective.codePostal
        );
        setFieldValue("exploitationDemarcheMillesime.communeAuditeurExterne", selectedStructureCollective.commune);
      }
    }
  }

  /**
   * Vérifie que le champ comporte que des chiffres et vérifie sa longueur
   * @param event input element
   * @param componentName nom de l'élément sur lequel la vérification est éffectué
   * @param maxLength longueur max du champ (10 par défaut)
   */
  validateNumber = (event, componentName, maxLength = 10) => {
    const { setFieldValue } = this.props;
    let input = event.target.value;
    //remplace tout ce qui n'est pas un chiffre par une chaine vide
    input = input.replace(/\D/g, "");
    if (input.length > maxLength) {
      input = input.slice(0, maxLength);
    }
    setFieldValue(componentName, input, true);
  };

  loadOrganisme = async () => {
    const idOrganisme = this.props.values.exploitationDemarcheMillesime.idOrganisme;
    let organisme = idOrganisme === "" ? null : await network.fetch(`/api/organismes/${idOrganisme}`);
    this.setState({ organisme });
  };

  renderOrganismeCertificateur = () => {
    const { t, organismes, values } = this.props;
    const { organisme } = this.state;
    return (
      <Box className="d-flex flex-column mb-2">
        <Typography variant="h3" className="mb-2">
          {t("demarche.organisme-certificateur", "Organisme")}
        </Typography>

        <Box className="d-flex">
          <Box className="flex-fill d-flex flex-column align-items-start">
            <Field
              component={TextField}
              select
              name="exploitationDemarcheMillesime.idOrganisme"
              label={t("demarche.organisme-certificateur", "Organisme")}
              variant="outlined"
              className="mb-1"
              fullWidth={false}
              style={{ width: 250 }}
            >
              <MenuItem value="">
                <em>{t("none.term.singular", "Aucun")}</em>
              </MenuItem>
              {organismes.map((organisme) => (
                <MenuItem key={organisme.idOrganisme} value={organisme.idOrganisme}>
                  {organisme.nom}
                </MenuItem>
              ))}
            </Field>
            <img
              src={organisme?.logoBase64}
              style={{
                maxHeight: "50px",
                margin: "1em",
              }}
              alt=""
            />
          </Box>
          <Box className="flex-fill d-flex flex-column">
            <Typography variant="h5" className="mb-1">
              {t("demarche.contrat-organisme-certificateur", "Contrat ou engagement avec l'organisme certificateur")}
            </Typography>
            <DocumentInput
              document={values.contratOrganisme}
              typeDocumentCode={typesDocumentsCodes.CONTRAT_ORGANISME}
              onSelect={(document) => {
                this.props.setFieldValue("exploitationDemarcheMillesime.contratOrganisme", document.idDocument);
                this.props.setFieldValue("contratOrganisme", document);
              }}
              onRemove={() => {
                this.props.setFieldValue("exploitationDemarcheMillesime.contratOrganisme", null);
                this.props.setFieldValue("contratOrganisme", null);
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  };

  renderGestionCertification = () => {
    const { t, values, demarche, structureCollective, millesime, organismeExterne, errors } = this.props;
    const typeAudit = [
      {
        code: codes.typesAuditCodes.INITIAL,
        libelle: "Initial",
      },
      {
        code: codes.typesAuditCodes.SUIVI,
        libelle: "Suivi",
      },
      {
        code: codes.typesAuditCodes.RENOUVELLEMENT,
        libelle: "Renouvellement",
      },
    ];
    if (values.exploitationDemarche.estCollective === "true")
      typeAudit.push({
        code: codes.typesAuditCodes.DEUXIEME_SUIVI,
        libelle: "2ème suivi (cadre collectif)",
      });
    const natureAudit = [
      {
        code: null,
        libelle: "",
      },
      {
        code: "INTERNE",
        libelle: "Interne",
      },
      {
        code: "EXTERNE",
        libelle: "Externe",
      },
    ];
    const localisations = [
      {
        code: "SURPLACE",
        libelle: "Sur place",
      },
      {
        code: "ADISTANCE",
        libelle: "A distance",
      },
    ];

    return (
      <Box className="d-flex flex-column mt-2 mb-2">
        <Typography variant="h3" className="mb-2">
          {t("demarche.gestion-certification", "Contexte de l'audit")}
        </Typography>
        <Box className="d-flex">
          <Box className="flex-fill d-flex flex-column align-items-start">
            <div className="d-flex flex-column">
              <FormControlLabel
                control={
                  <Field
                    component={DatePicker}
                    name="exploitationDemarcheMillesime.dateAudit"
                    invalidDateMessage={t("invalid-date", "Date invalide")}
                    error={errors.dateAudit ? errors.dateAudit : ""}
                    helperText={errors.dateAudit ? errors.dateAudit : ""}
                  />
                }
                label={<Typography style={{ width: 250 }}>{t("demarche.date-audit", "Date de l'audit")}</Typography>}
                labelPlacement="start"
                className="mt-1"
              />
            </div>
            {demarche.code === HVE4Static.codeNational && (
              <>
                <FormControlLabel
                  control={
                    <Field component={RadioGroup} name={"exploitationDemarche.estCollective"} className="mt-1 ml-1">
                      <FormControlLabel
                        value={"false"}
                        control={<Radio color="primary" />}
                        label={t("demarche.certification-individuelle", "Certification individuelle directe")}
                      />
                      <FormControlLabel
                        value={"true"}
                        control={<Radio color="primary" />}
                        label={t(
                          "demarche.certification-collective",
                          "Certification individuelle dans un cadre collectif"
                        )}
                      />
                    </Field>
                  }
                  label={
                    <Typography style={{ width: 250 }}>
                      {t("demarche.cadre-certification", "Cadre de la certification")}
                    </Typography>
                  }
                  labelPlacement="start"
                  className="mt-1"
                />

                <div className="d-flex flex-row">
                  <FormControlLabel
                    control={
                      <Field
                        component={TextField}
                        select
                        name="exploitationDemarche.typeAudit"
                        variant="outlined"
                        fullWidth={false}
                        style={{ width: 200 }}
                      >
                        {typeAudit.map((audit) => (
                          <MenuItem key={audit.code} value={audit.code}>
                            {audit.libelle}
                          </MenuItem>
                        ))}
                      </Field>
                    }
                    label={<Typography style={{ width: 250 }}>{t("demarche.type-audit", "Type d'audit")}</Typography>}
                    labelPlacement="start"
                    className="mt-1"
                  />
                  <FormControlLabel
                    control={
                      <Field
                        style={{ width: 200 }}
                        component={TextField}
                        name="exploitationDemarcheMillesime.campagneEvaluee"
                      />
                    }
                    label={
                      <Typography style={{ width: 250 }}>
                        {t("demarche.campagne-evaluee", "Campagne évaluée")}
                      </Typography>
                    }
                    labelPlacement="start"
                    className={"mt-1 ml-3"}
                  />
                </div>
              </>
            )}
            <div className="d-flex mr-2">
              <FormControlLabel
                control={
                  <div className={"d-flex"}>
                    <Field
                      component={TextField}
                      name="exploitationDemarcheMillesime.certificateurExterne"
                      variant="outlined"
                      fullWidth={false}
                      style={{ width: 200 }}
                      select
                    >
                      {organismeExterne
                        .filter((o) => o.millesimefinvalide >= millesime.idMillesime || o.millesimefinvalide == null)
                        .map((organisme) => (
                          <MenuItem key={organisme.idOrganismeExterne} value={organisme.idOrganismeExterne}>
                            {organisme.libelle}
                          </MenuItem>
                        ))}
                    </Field>
                  </div>
                }
                label={
                  <Typography style={{ width: 250 }}>
                    {t("demarche.organisme-certificateur", "Organisme certificateur")}
                  </Typography>
                }
                labelPlacement="start"
                className={"mt-1"}
              />
              {["18", 18].includes(values.exploitationDemarcheMillesime.certificateurExterne) && (
                <div className={"d-flex mr-2"}>
                  <FormControlLabel
                    control={
                      <Field
                        component={TextField}
                        name="exploitationDemarcheMillesime.certificateurExterneAutre"
                        label={"Autre organisme"}
                        variant="outlined"
                        fullWidth={false}
                        style={{ width: 200 }}
                      />
                    }
                    labelPlacement="start"
                    className="mt-1 ml-3"
                  />
                </div>
              )}
              <FormControlLabel
                control={
                  <Field
                    component={TextField}
                    name={"exploitationDemarche.dureeAudit"}
                    fullWidth={false}
                    style={{ width: 200 }}
                    error={errors.dureeAudit ? errors.dureeAudit : ""}
                    helperText={errors.dureeAudit ? errors.dureeAudit : ""}
                  />
                }
                className="mt-1 ml-3"
                label={<Typography style={{ width: 250 }}>{t("demarche.duree-audit", "Durée de l'audit")}</Typography>}
                labelPlacement={"start"}
              />
            </div>
            <div className={"d-flex flex-row"}>
              <FormControlLabel
                control={
                  <Field
                    component={TextField}
                    name="exploitationDemarcheMillesime.nomAuditeurExterne"
                    label={t("demarche.nom-auditeur-externe", "Nom")}
                    variant="outlined"
                    fullWidth={false}
                    style={{ width: 200 }}
                  />
                }
                className="mt-1"
                label={<Typography style={{ width: 250 }}>{t("demarche.auditeur-externe", "Auditeur")}</Typography>}
                labelPlacement={"start"}
              />
              <FormControlLabel
                control={
                  <Field
                    component={TextField}
                    name="exploitationDemarcheMillesime.prenomAuditeurExterne"
                    label={t("demarche.prenom-auditeur-externe", "Prénom")}
                    variant="outlined"
                    fullWidth={false}
                    style={{ width: 200 }}
                  />
                }
                className="mt-1 ml-3"
                labelPlacement={"start"}
              />
            </div>
            {values.exploitationDemarche.estCollective === "true" && demarche.code === HVE4Static.codeNational && (
              <React.Fragment>
                <Typography className={"mt-2 ml-1"} variant={"h5"} color={"primary"}>
                  Cadre collectif : Renseignez la nature de l'audit et les informations obligatoires sur la structure
                  collective.
                </Typography>
                <div className={"d-flex mr-2"}>
                  <FormControlLabel
                    control={
                      <Field
                        component={TextField}
                        select
                        defaultValue={natureAudit[0].code}
                        name="exploitationDemarcheMillesime.natureAudit"
                        variant="outlined"
                        fullWidth={false}
                        style={{ width: 200 }}
                      >
                        {natureAudit.map(
                          (audit) =>
                            audit.code && (
                              <MenuItem key={audit.code} value={audit.code}>
                                {audit.libelle}
                              </MenuItem>
                            )
                        )}
                      </Field>
                    }
                    label={
                      <Typography style={{ width: 250 }}>{t("demarche.nature-audit", "Nature de l'audit")}</Typography>
                    }
                    labelPlacement="start"
                    className="mt-1"
                  />
                </div>
                {values.exploitationDemarcheMillesime.natureAudit === "INTERNE" && (
                  <div className={"d-flex mr-2"}>
                    <FormControlLabel
                      control={
                        <Field
                          component={TextField}
                          select
                          name="exploitationDemarcheMillesime.localisation"
                          variant="outlined"
                          fullWidth={false}
                          style={{ width: 200 }}
                        >
                          {localisations.map(
                            (localisation) =>
                              localisation.code && (
                                <MenuItem key={localisation.code} value={localisation.code}>
                                  {localisation.libelle}
                                </MenuItem>
                              )
                          )}
                        </Field>
                      }
                      label={
                        <Typography style={{ width: 250 }}>{t("demarche.localisation", "Localisation")}</Typography>
                      }
                      labelPlacement="start"
                      className="mt-1"
                    />
                  </div>
                )}
                <div className={"d-flex mr-2"}>
                  <FormControlLabel
                    control={
                      <Field
                        select
                        component={TextField}
                        name="exploitationDemarcheMillesime.nomStructureCollective"
                        fullWidth={false}
                        style={{ width: 200 }}
                      >
                        {structureCollective
                          .filter(
                            (sc) => sc.millesimefinvalidite >= millesime.idMillesime || sc.millesimefinvalidite == null
                          )
                          .map(
                            (structure) =>
                              structure.idStructureCollective && (
                                <MenuItem key={structure.idStructureCollective} value={structure.idStructureCollective}>
                                  {structure.libelle}
                                </MenuItem>
                              )
                          )}
                      </Field>
                    }
                    label={
                      <Typography style={{ width: 250 }}>
                        {t("demarche.nom-structure-collective", "Nom de la structure collective")}
                      </Typography>
                    }
                    labelPlacement="start"
                    className={"mt-1"}
                  />
                </div>
                <div className={"d-flex mr-2"}>
                  <FormControlLabel
                    control={
                      <Field
                        component={TextField}
                        name="exploitationDemarcheMillesime.siret"
                        fullWidth={false}
                        style={{ width: 200 }}
                        onChange={(event) => this.validateNumber(event, "exploitationDemarcheMillesime.siret", 14)}
                        error={errors.siret ? errors.siret : ""}
                        helperText={errors.siret ? errors.siret : ""}
                      />
                    }
                    label={<Typography style={{ width: 250 }}>{t("demarche.Siret", "Siret")}</Typography>}
                    labelPlacement="start"
                    className={"mt-1"}
                  />
                </div>
                <div className={"d-flex mr-2"}>
                  <FormControlLabel
                    control={
                      <Field
                        component={TextField}
                        name="exploitationDemarcheMillesime.adresseAuditeurExterne"
                        fullWidth={false}
                        style={{ width: 200 }}
                      />
                    }
                    label={
                      <Typography style={{ width: 250 }}>
                        {t("demarche.adresse-auditeur-externe", "Adresse")}
                      </Typography>
                    }
                    labelPlacement="start"
                    className={"mt-1"}
                  />
                  <FormControlLabel
                    control={
                      <Field
                        component={TextField}
                        name="exploitationDemarcheMillesime.adresse2AuditeurExterne"
                        fullWidth={false}
                        style={{ width: 200 }}
                      />
                    }
                    label={
                      <Typography style={{ width: 250 }}>
                        {t("demarche.adresse2-auditeur-externe", "Adresse complémentaire")}
                      </Typography>
                    }
                    labelPlacement="start"
                    className={demarche.code === HVE4Static.codeNational ? "mt-1 ml-3" : "mt-1"}
                  />
                </div>
                <div className={"d-flex mr-2"}>
                  <FormControlLabel
                    control={
                      <Field
                        component={TextField}
                        name="exploitationDemarcheMillesime.codePostalAuditeurExterne"
                        fullWidth={false}
                        style={{ width: 200 }}
                      />
                    }
                    label={
                      <Typography style={{ width: 250 }}>
                        {t("demarche.code-postal-auditeur-externe", "Code postal")}
                      </Typography>
                    }
                    labelPlacement="start"
                    className={"mt-1"}
                  />
                  <FormControlLabel
                    control={
                      <Field
                        component={TextField}
                        name="exploitationDemarcheMillesime.communeAuditeurExterne"
                        fullWidth={false}
                        style={{ width: 200 }}
                      />
                    }
                    label={
                      <Typography style={{ width: 250 }}>
                        {t("demarche.commune-auditeur-externe", "Commune")}
                      </Typography>
                    }
                    labelPlacement="start"
                    className={demarche.code === HVE4Static.codeNational ? "mt-1 ml-3" : "mt-1"}
                  />
                </div>
              </React.Fragment>
            )}
            {demarche.code === HVE1.codeNational && (
              <FormControlLabel
                control={
                  <Field component={Switch} type="checkbox" name="exploitationDemarche.aidePac" color="primary" />
                }
                label={t("demarche.aides-pac", "Exploitation bénéficiant des aides PAC")}
                className="mt-1"
              />
            )}
          </Box>
          {demarche.code !== HVE4Static.codeNational && (
            <Box className="flex-fill mx-2">
              <h3>Certification niveau 1</h3>
              <div className="d-flex flex-column align-items-start">
                <FormControlLabel
                  control={
                    <Field
                      component={Switch}
                      type="checkbox"
                      name="exploitationDemarche.hve1Atteinte"
                      color="primary"
                    />
                  }
                  labelPlacement="start"
                  label={
                    <Typography style={{ width: 250 }}>
                      {t("demarche.certification-niveau-1-atteinte", "Certification niveau 1 atteinte")}
                    </Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Field
                      component={DatePicker}
                      name="exploitationDemarche.hve1Date"
                      invalidDateMessage={t("invalid-date", "Date invalide")}
                    />
                  }
                  label={
                    <Typography style={{ width: 250 }}>
                      {t("demarche.date-certification-niveau-1", "Date de certification de niveau 1")}
                    </Typography>
                  }
                  className="mt-1"
                  labelPlacement="start"
                />
                <Box className="flex-fill d-flex flex-column mt-1">
                  <DocumentInput
                    name="exploitationDemarche.documentHve1"
                    document={values.documentHve1}
                    onSelect={(document) => {
                      let listDocuments = this.props.values.documentHve1 || [];
                      listDocuments.push(document);
                      this.props.setFieldValue("exploitationDemarche.documentHve1", listDocuments);
                      this.props.setFieldValue("documentHve1", listDocuments);
                    }}
                    onRemove={(index) => {
                      let listDocument = [
                        ...values.documentHve1.slice(0, index),
                        ...values.documentHve1.slice(index + 1),
                      ];
                      this.props.setFieldValue("exploitationDemarche.documentHVE1", listDocument);
                      this.props.setFieldValue("documentHve1", listDocument);
                    }}
                  />
                </Box>
                <h3 className="mt-3">Certification niveau 2</h3>
                <FormControlLabel
                  control={
                    <Field
                      component={Switch}
                      type="checkbox"
                      name="exploitationDemarche.hve2Atteinte"
                      color="primary"
                    />
                  }
                  labelPlacement="start"
                  label={
                    <Typography style={{ width: 250 }}>
                      {t("demarche.certification-niveau-2-atteinte", "Certification niveau 2 atteinte")}
                    </Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Field
                      component={DatePicker}
                      name="exploitationDemarche.hve2Date"
                      invalidDateMessage={t("invalid-date", "Date invalide")}
                    />
                  }
                  label={
                    <Typography style={{ width: 250 }}>
                      {t("demarche.date-certification-niveau-2", "Date de certification de niveau 2")}
                    </Typography>
                  }
                  className="mt-1"
                  labelPlacement="start"
                />
                <Box className="flex-fill d-flex flex-column mt-1">
                  <DocumentInput
                    name="exploitationDemarche.documentHve2"
                    document={values.documentHve2}
                    onSelect={(document) => {
                      let listDocuments = this.props.values.documentHve2 || [];
                      listDocuments.push(document);
                      this.props.setFieldValue("exploitationDemarche.documentHve2", listDocuments);
                      this.props.setFieldValue("documentHve2", listDocuments);
                    }}
                    onRemove={(index) => {
                      let listDocument = [
                        ...values.documentHve2.slice(0, index),
                        ...values.documentHve2.slice(index + 1),
                      ];
                      this.props.setFieldValue("exploitationDemarche.documentHVE2", listDocument);
                      this.props.setFieldValue("documentHve2", listDocument);
                    }}
                  />
                </Box>
                <Field
                  className="mt-3"
                  component={TextField}
                  name="exploitationDemarche.commentaireGeneral"
                  label={t("demarche.commentaire-general", "Commentaire général")}
                  multiline
                  rows={8}
                  variant="outlined"
                />
              </div>
            </Box>
          )}
        </Box>
        <Box className="d-flex mt-2 justify-between">
          {values.exploitationDemarche.estCollective === "true" && (
            <Box className="d-flex flex-column flex-fill">
              <Typography variant="h5" className="mb-1">
                {t("demarche.contrat-structure-collective", "Contrat avec la structure collective")}
              </Typography>
              <DocumentInput
                document={values.contratStructureCollective}
                typeDocumentCode={typesDocumentsCodes.CONTRAT_STRUCTURE_COLLECTIVE}
                onSelect={(document) => {
                  this.props.setFieldValue("exploitationDemarche.contratStructureCollective", document.idDocument);
                  this.props.setFieldValue("contratStructureCollective", document);
                }}
                onRemove={() => {
                  this.props.setFieldValue("exploitationDemarche.contratStructureCollective", null);
                  this.props.setFieldValue("contratStructureCollective", null);
                }}
              />
            </Box>
          )}
          <Box className="d-flex flex-column flex-fill">
            <Typography variant="h5" className="mb-1">
              {t("demarche.fiche-annuaire", "Fiche annuaire")}
            </Typography>
            <DocumentInput
              document={values.ficheAnnuaire}
              typeDocumentCode={typesDocumentsCodes.FICHE_ANNUAIRE}
              onSelect={(document) => {
                this.props.setFieldValue("exploitationDemarche.ficheAnnuaire", document.idDocument);
                this.props.setFieldValue("ficheAnnuaire", document);
              }}
              onRemove={() => {
                this.props.setFieldValue("exploitationDemarche.ficheAnnuaire", null);
                this.props.setFieldValue("ficheAnnuaire", null);
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  };

  renderCertificationsExploitation = () => {
    const { t, nomDemarche, millesime } = this.props;
    return (
      <Box className="d-flex flex-column mt-2 mb-2">
        <Typography variant="h3" className="mb-2">
          {t("demarche.certifications-exploitation", "Autres certifications de l’exploitation")}
        </Typography>
        <Box className="flex-fill mx-2">
          <h3>Niveau 2</h3>
          <div className="d-flex align-items-start flex-column">
            <FormControlLabel
              control={
                <Field component={Switch} type="checkbox" name="exploitationDemarche.equivalenceN2" color="primary" />
              }
              labelPlacement="start"
              style={{ height: 51 }}
              label={
                <Typography style={{ width: 250 }}>{t("demarche.equivalence-n2", "Equivalence niveau 2")}</Typography>
              }
            />
            <FormControlLabel
              label={<Typography style={{ width: 250 }}> {t("demarche.nom-demarche-n2", "Nom démarche")}</Typography>}
              control={
                <Field
                  component={TextField}
                  select
                  name="exploitationDemarche.nomDemarcheN2"
                  variant="outlined"
                  fullWidth={false}
                  style={{ width: 200 }}
                >
                  {nomDemarche
                    .filter((nd) => nd.millesimefinvalide >= millesime.idMillesime || nd.millesimefinvalide == null)
                    .map((nomCertification) => (
                      <MenuItem key={nomCertification.id} value={nomCertification.id}>
                        {nomCertification.libelle}
                      </MenuItem>
                    ))}
                </Field>
              }
              labelPlacement="start"
            />
          </div>
          <h3 className="mt-3">Autres démarches</h3>
          <div className="d-flex align-items-start flex-wrap">
            <FormControlLabel
              label={<Typography> {t("demarche.autre-demarche-1", "Autre démarche 1")}</Typography>}
              control={
                <Field
                  component={TextField}
                  select
                  name="exploitationDemarche.autreDemarche1"
                  variant="outlined"
                  fullWidth={false}
                  style={{ width: 280 }}
                  className={"ml-2"}
                >
                  {this.props.nomAutresDemarches.map((nomAutresDemarches) => (
                    <MenuItem key={nomAutresDemarches.idAutreDemarcheQualite} value={nomAutresDemarches.libelle}>
                      {nomAutresDemarches.libelle}
                    </MenuItem>
                  ))}
                </Field>
              }
              labelPlacement="start"
            />
            <FormControlLabel
              label={<Typography> {t("demarche.autre-demarche-2", "Autre démarche 2")}</Typography>}
              className="ml-3"
              control={
                <Field
                  component={TextField}
                  select
                  name="exploitationDemarche.autreDemarche2"
                  variant="outlined"
                  fullWidth={false}
                  className={"ml-2"}
                  style={{ width: 280 }}
                >
                  {this.props.nomAutresDemarches.map((nomAutresDemarches) => (
                    <MenuItem key={nomAutresDemarches.idAutreDemarcheQualite} value={nomAutresDemarches.libelle}>
                      {nomAutresDemarches.libelle}
                    </MenuItem>
                  ))}
                </Field>
              }
              labelPlacement="start"
            />
            <FormControlLabel
              label={<Typography> {t("demarche.autre-demarche-3", "Autre démarche 3")}</Typography>}
              className="ml-3"
              control={
                <Field
                  component={TextField}
                  select
                  name="exploitationDemarche.autreDemarche3"
                  variant="outlined"
                  fullWidth={false}
                  className={"ml-2"}
                  style={{ width: 280 }}
                >
                  {this.props.nomAutresDemarches.map((nomAutresDemarches) => (
                    <MenuItem key={nomAutresDemarches.idAutreDemarcheQualite} value={nomAutresDemarches.libelle}>
                      {nomAutresDemarches.libelle}
                    </MenuItem>
                  ))}
                </Field>
              }
              labelPlacement="start"
            />
          </div>
          <Field
            className="mt-3"
            component={TextField}
            name="exploitationDemarche.commentaireGeneral"
            label={t("demarche.commentaire-general", "Commentaire général")}
            multiline
            rows={8}
            variant="outlined"
          />
        </Box>
      </Box>
    );
  };

  renderCertificationEquivalente = () => {
    const { t, certificationsEquivalentes, values } = this.props;

    const estCertificationEquivalente = values.exploitationDemarche.estCertificationEquivalente;

    return (
      <fieldset className="mt-2" style={estCertificationEquivalente ? {} : { border: 0 }}>
        <legend>
          <FormControlLabel
            control={
              <Field
                component={Switch}
                type="checkbox"
                name="exploitationDemarche.estCertificationEquivalente"
                color="primary"
              />
            }
            label={
              <Typography variant="h5">
                {t("demarche.avec-equivalence", "Certification obtenue avec une équivalence")}
              </Typography>
            }
          />
        </legend>
        {estCertificationEquivalente && (
          <Box className="d-flex flex-column align-items-start">
            <FormControlLabel
              control={
                <Field
                  component={TextField}
                  select
                  name="exploitationDemarche.certificationEquivalenteEstTotale"
                  variant="outlined"
                  className="mb-1"
                  fullWidth={false}
                  style={{ width: 250 }}
                >
                  {[
                    {
                      id: "true",
                      libelle: "Totale",
                    },
                    {
                      id: "false",
                      libelle: "Partielle",
                    },
                  ].map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.libelle}
                    </MenuItem>
                  ))}
                </Field>
              }
              label={
                <Typography style={{ width: 200 }}>{t("certification.term.singular", "Certification")}</Typography>
              }
              labelPlacement="start"
            />
            <FormControlLabel
              control={
                <Field
                  component={TextField}
                  select
                  name="exploitationDemarche.certificationEquivalenteType"
                  variant="outlined"
                  className="mb-1"
                  fullWidth={false}
                  style={{ width: 250 }}
                >
                  {certificationsEquivalentes.map((certificationEquivalente) => (
                    <MenuItem
                      key={certificationEquivalente.idCertificationEquivalente}
                      value={certificationEquivalente.idCertificationEquivalente}
                    >
                      {certificationEquivalente.libelle}
                    </MenuItem>
                  ))}
                </Field>
              }
              label={
                <Typography style={{ width: 200 }}>
                  {t("demarche.type-certification", "Type de certification")}
                </Typography>
              }
              labelPlacement="start"
            />
            <FormControlLabel
              control={
                <Field
                  component={DatePicker}
                  name="exploitationDemarche.certificationEquivalenteDateCertification"
                  invalidDateMessage={t("invalid-date", "Date invalide")}
                />
              }
              label={
                <Typography style={{ width: 200 }}>
                  {t("demarche.date-certification", "Date de la certification")}
                </Typography>
              }
              labelPlacement="start"
            />
            <FormControlLabel
              control={
                <Field
                  component={DatePicker}
                  name="exploitationDemarche.certificationEquivalenteDateAudit"
                  invalidDateMessage={t("invalid-date", "Date invalide")}
                />
              }
              label={<Typography style={{ width: 200 }}>{t("demarche.date-audit", "Date de l'audit")}</Typography>}
              labelPlacement="start"
              className="mt-1"
            />
            <Box className="d-flex flex-column mt-2">
              <Typography variant="h5" className="mb-1">
                {t("demarche.document-certification-equivalente", "Document de certification équivalente")}
              </Typography>
              <DocumentInput
                document={values.certificationEquivalenteDocument}
                typeDocumentCode={typesDocumentsCodes.CERTIFICATION_EQUIVALENTE}
                onSelect={(document) => {
                  this.props.setFieldValue(
                    "exploitationDemarche.certificationEquivalenteDocument",
                    document.idDocument
                  );
                  this.props.setFieldValue("certificationEquivalenteDocument", document);
                }}
                onRemove={() => {
                  this.props.setFieldValue("exploitationDemarche.certificationEquivalenteDocument", null);
                  this.props.setFieldValue("certificationEquivalenteDocument", null);
                }}
              />
            </Box>
          </Box>
        )}
      </fieldset>
    );
  };

  render() {
    const { t, demarche, isSubmitting, isValid } = this.props;

    return (
      <React.Fragment>
        <Typography variant="h1" className="mb-2">
          {demarche.libelle}
        </Typography>
        <Card className="flex-fill">
          <CardContent>
            <Form className="d-flex flex-column">
              {this.renderOrganismeCertificateur()}
              <React.Fragment>
                <Divider />
                {this.renderGestionCertification()}
              </React.Fragment>
              {demarche.code === HVE4Static.codeNational && (
                <React.Fragment>
                  <Divider />
                  {this.renderCertificationsExploitation()}
                </React.Fragment>
              )}
              {[HVE1.codeNational, HVE2.codeNational].includes(demarche.code) && (
                <React.Fragment>
                  <Divider />
                  {this.renderCertificationEquivalente()}
                </React.Fragment>
              )}

              <Button
                disabled={!isValid || isSubmitting}
                color="primary"
                variant="contained"
                type="submit"
                className="mt-1 align-self-center"
              >
                {isSubmitting ? <CircularProgress size={24} /> : t("validate", "Valider")}
              </Button>
              {!isValid && (
                <Alert severity="error" className="mt-1">
                  <AlertTitle>
                    <strong>{t("form-missing-data.title", "Impossible de valider")}</strong>
                  </AlertTitle>
                  {t(
                    "form-missing-data.message",
                    "Des données sont manquantes ou erronnées lors de la saisie du formulaire."
                  )}
                </Alert>
              )}
            </Form>
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}

/**
 * On vérifie que le siret soit valide
 * @param value valeur du siret
 * @returns {boolean} vrai si le siret est conforme
 */
const isSiretValid = (value) => {
  let siret = value.toString().split("");
  if (siret[0] === "0") return true;
  let resultValue = 0;
  for (let i = 0; i < siret.length; i++) {
    if (i % 2 === 0) {
      if (siret[i] * 2 > 9) {
        let result = (siret[i] * 2).toString();
        siret[i] = parseInt(result[0]) + parseInt(result[1]);
      } else {
        siret[i] = siret[i] * 2;
      }
    }
    resultValue += parseInt(siret[i]);
  }
  return resultValue.toString()[1] === "0";
};

const validate = (values, props) => {
  const { t } = props,
    errors = {};
  if (values.exploitationDemarche.estCollective === "true") {
    if (!values.exploitationDemarcheMillesime.siret?.length) {
      errors.siret = t("modif-exploitation.error.required", "Champ obligatoire");
    } else if (values.exploitationDemarcheMillesime.siret?.length !== 14) {
      errors.siret = t("exploitationDemarcheMillesime.siret", "Le siret doit avoir une taille de 14");
    } else if (!isSiretValid(values.exploitationDemarcheMillesime.siret)) {
      errors.siret = t("exploitationDemarcheMillesime.siret", "Le siret n'est pas valide");
    }
  }

  if (!values.exploitationDemarche.dureeAudit)
    errors.dureeAudit = t("modif-exploitation.error.required", "Champ obligatoire");

  if (!values.exploitationDemarcheMillesime.dateAudit)
    errors.dateAudit = t("modif-exploitation.error.required", "Champ obligatoire");

  return errors;
};

const mapPropsToValues = (props) => {
  let {
    exploitationDemarche,
    exploitationDemarcheMillesime,
    contratOrganisme,
    documentHve1,
    documentHve2,
    contratStructureCollective,
    ficheAnnuaire,
    certificationEquivalenteDocument,
  } = props.exploitationDemarcheInfo;

  exploitationDemarche = replaceNullByEmptyString(
    {
      hve1Date: null,
      hve2Date: null,
      hve1Atteinte: false,
      hve2Atteinte: false,
      estCollective: false,
      aidePac: false,
      commentaireGeneral: "",
      contratStructureCollective: null,
      documentHve1: null,
      documentHve2: null,
      ficheAnnuaire: null,
      estCertificationEquivalente: false,
      certificationEquivalenteEstTotale: null,
      certificationEquivalenteType: null,
      certificationEquivalenteDateCertification: null,
      certificationEquivalenteDateAudit: null,
      certificationEquivalenteDocument: null,
      nomDemarcheN2: "",
      typeAudit: codes.typesAuditCodes.INITIAL,
      dureeAudit: "",
      ...exploitationDemarche,
    },
    ["certificationEquivalenteType"]
  );
  exploitationDemarche.estCollective = String(exploitationDemarche.estCollective);

  exploitationDemarcheMillesime = replaceNullByEmptyString(
    {
      idOrganisme: null,
      contratOrganisme: null,
      dateAudit: null,
      dateCertification: null,
      periodeAuditeeDebut: null,
      periodeAuditeeFin: null,
      certificateurExterne: "",
      natureAudit: "",
      nomStructureCollective: "",
      siret: "",
      localisation: "",
      ...exploitationDemarcheMillesime,
    },
    ["idOrganisme"]
  );

  return {
    exploitationDemarche,
    exploitationDemarcheMillesime,
    contratOrganisme,
    documentHve1,
    documentHve2,
    contratStructureCollective,
    ficheAnnuaire,
    certificationEquivalenteDocument,
  };
};

const handleSubmit = async (values, { props, setSubmitting }) => {
  const exploitationDemarche = replaceMomentObjectByString(
    replaceEmptyStringByNull(values.exploitationDemarche, ["certificationEquivalenteType"])
  );
  const exploitationDemarcheMillesime = replaceMomentObjectByString(
    replaceEmptyStringByNull(values.exploitationDemarcheMillesime, ["idOrganisme"])
  );

  const documentHve1 = values.documentHve1;
  const documentHve2 = values.documentHve2;

  await props.onSubmit({
    exploitationDemarche,
    exploitationDemarcheMillesime,
    documentHve1,
    documentHve2,
  });
  if (this.state.mounted) {
    setSubmitting(false);
  }
};

export default connect(mapStateToProps)(
  withRouter(
    withTranslation()(
      withFormik({
        mapPropsToValues: mapPropsToValues,
        mapStateToProps: mapStateToProps,
        validate: validate,
        handleSubmit: handleSubmit,
        validateOnMount: true,
        validateOnChange: true,
        validateOnBlur: false,
      })(DemarcheForm)
    )
  )
);
